import styled from 'styled-components';

const Hero = styled.div`
  padding:5px 0 5px 0;
  ${(props) => props.theme.breakpoints.up('lg')} {
    padding:20px 0 20px 0;
  }
  color: ${(props) => props.theme.palette.common.tan};
  h1 {
    margin:0 0 5px 0;
    text-align:center;
    display:block;
    font-size:24px;
    ${(props) => props.theme.breakpoints.up('lg')} {
      font-size:36px;
    }
  
    font-weight: 400;
  }
  h2 {
    margin:0 0 5px 0;
    text-align:center;
    display:block;
    font-size:36px;
    font-weight: 300;
    font-family: 'Roboto', 'sans-serif';
    ${(props) => props.theme.breakpoints.up('lg')} {
      font-size:55px;
    }
  }
  h3 {
    margin:0 0 5px 0;
    text-align:center;
    display:block;
    font-size:28px;
    ${(props) => props.theme.breakpoints.up('lg')} {
      font-size:32px;
    }
    font-weight: 300;
  }
  h4 {
    margin:0 0 5px 0;
    text-align:center;
    display:block;
    font-size:24px;
    ${(props) => props.theme.breakpoints.up('lg')} {
      font-size:28px;
    }
    font-weight: 300;
    font-family: 'Roboto', 'sans-serif';
  }
  h6 {
    margin:0 0 5px 0;
    text-align:center;
    display:block;
    font-size:16px;
  }

  .valuation {
    ${(props) => props.theme.breakpoints.up('lg')} {
      padding-bottom: 35px; 
    }
  }

  .platformsTitle,
  .smallTitle {
    font-weight: 400;
  }

  .dot {
    width: 12px;
    height: 12px;
    border-radius: 100%;

    &.other {
      border: 1px solid ${(props) => props.theme.palette.product.other};
    }
    &.bond, &.offshore-bond-sub-plan {
      border: 1px solid ${(props) => props.theme.palette.product.bond};
    }
    &.giagross, &.pension, &.pension-sub-plan {
      border: 1px solid ${(props) => props.theme.palette.product.pension};
    },
    &.isa, &.jisa {
      border: 1px solid ${(props) => props.theme.palette.product.isa};
    },
    &.gia {
      border: 1px solid ${(props) => props.theme.palette.product.gia};
    },
  }
  
  .productCategoryContainer {
    display: inline-block;
    text-align: center;

      & .productCategoryBar {
        display: block;
        border-radius: 2px;
        height: 4px;
        margin: 10px 0 15px;
        width: 0;
        transition: width 0.5s 1s ease-in-out;
          background-color: ${(props) => props.theme.palette.common.white};

          &.other {
              background-color: ${(props) => props.theme.palette.product.other};
          }
          &.bond, &.offshore-bond-sub-plan {
              background-color: ${(props) => props.theme.palette.product.bond};
          }
          &.giagross, &.pension, &.pension-sub-plan {
              background-color: ${(props) =>
                props.theme.palette.product.pension};
          }
          &.isa, &.jisa {
              background-color: ${(props) => props.theme.palette.product.isa};
          }
          &.gia {
              background-color: ${(props) => props.theme.palette.product.gia};
          }
      }
      .slick-slide.slick-active & {
        & .productCategoryBar.productCategoryBarActive {
          width: 100%!important;
        }
      }
  }

  .textGrey {
    font-weight: 400;
    color: ${(props) => props.theme.palette.common.grey};
  }
`;

export default Hero;
